import React, { useEffect } from "react";
import BlogCard from "./BlogCard";
import BlogCategory from "./BlogCategory";
import "./Blogs.css";
import { blogCardData, blogCategoryData } from "./json";
import Footer from "../../component/footer";
import useBlog from "../../Hooks/useBlog";

function Blog() {
  const { data } = useBlog();

  return (
    <>
      <section className="blog-main-sec">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-12">
              <h1>Blogs</h1>
              <h2>Gaming Arcade</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="tabs-section">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-12">
              <h2>Categories</h2>
            </div>
          </div>
          <div className="row tabs-row">
            <div className="col-lg-12">
              {data?.map((item, index) => {
                return (
                  <p key={index}>
                    {item?.title ? item?.title : "No Data Found"}
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      <section className="blogs">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-12">
              <h3>trending</h3>
            </div>
          </div>
          <div className="row blogs-row">
            {blogCardData.slice(0, 2)?.map((item, index) => {
              return (
                <BlogCard
                  key={index}
                  date={item.date}
                  description={item.description}
                  imgSrc={require("../../Assets/img/blog-image.png")}
                />
              );
            })}
            <div className="col-lg-4">
              {blogCategoryData.slice(0, 3).map((item, index) => {
                return (
                  <BlogCategory
                    key={index}
                    date={item.date}
                    title={item.title}
                    description={item.description}
                    imgSrc={require("../../Assets/img/blog-2.png")}
                  />
                );
              })}
            </div>
          </div>
          <div className="row blogs-row">
            {blogCardData.slice(2, 5).map((item, index) => {
              return (
                <BlogCard
                  key={index}
                  date={item.date}
                  description={item.description}
                  imgSrc={require("../../Assets/img/blog-image.png")}
                />
              );
            })}
          </div>
        </div>
      </section>
      <section className="blogs">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-12">
              <h3>Crypto</h3>
            </div>
          </div>
          <div className="row blogs-row">
            {blogCardData.slice(5, 7).map((item, index) => {
              return (
                <BlogCard
                  key={index}
                  date={item.date}
                  description={item.description}
                  imgSrc={require("../../Assets/img/blog-image.png")}
                />
              );
            })}
            <div className="col-lg-4">
              {blogCategoryData.slice(3, 6).map((item, index) => {
                return (
                  <BlogCategory
                    key={index}
                    date={item.date}
                    title={item.title}
                    description={item.description}
                    imgSrc={require("../../Assets/img/blog-2.png")}
                  />
                );
              })}
            </div>
          </div>
          <div className="row blogs-row">
            {blogCardData.slice(7, 10).map((item, index) => {
              return (
                <BlogCard
                  key={index}
                  date={item.date}
                  description={item.description}
                  imgSrc={require("../../Assets/img/blog-image.png")}
                />
              );
            })}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
export default Blog;
